import { create } from 'zustand';

// ParticipationStatus 열거형 정의
export enum ParticipationStatus {
  CHECK_ELIGIBLE = 1, // 참가권 확인 가능(개인정보 동의 완료)
  NOT_AGREED = 2, // 참가권 받기 전(개인정보 동의 전)
  NO_TICKETS = 3, // 획득한 참가권 없음
}

interface ResponseData {
  status: ParticipationStatus;
  ticketCnt: number;
  ticketNo: number;
}

interface InfoState {
  mainInfo: Partial<ResponseData>;
  sideInfo: Partial<ResponseData>;
  setMainInfo: (info: Partial<ResponseData>) => void;
  setSideInfo: (info: Partial<ResponseData>) => void;
}

// Zustand 스토어 생성
const infoStore = create<InfoState>((set) => ({
  mainInfo: {
    status: ParticipationStatus.NO_TICKETS,
    ticketCnt: 0,
    ticketNo: 0,
  },
  sideInfo: {
    status: ParticipationStatus.NO_TICKETS,
    ticketCnt: 0,
    ticketNo: 0,
  },
  setMainInfo: (info: Partial<ResponseData>) =>
    set((state) => ({
      mainInfo: { ...state.mainInfo, ...info },
    })),
  setSideInfo: (info: Partial<ResponseData>) =>
    set((state) => ({
      sideInfo: { ...state.sideInfo, ...info },
    })),
}));

export { infoStore };
